module.exports = __webpack_public_path__ + "img/11_1.b6e3d116.jpg";